import { useEffect, useState } from "react";
import FullScreenLoader from "./FullScreenLoader";
import { languageManager } from "../../services/languageManager";

interface Props {
  children: React.ReactNode;
}

const LanguageLoader = ({ children }: Props) => {
  const [loading, setLoading] = useState(
    languageManager.getLoadingState()
  );

  useEffect(() => {
    const unsubscribe = languageManager.subscribe(setLoading);

    return unsubscribe;
  }, []);

  return (
    <>
      {loading && <FullScreenLoader />}
      {children}
    </>
  );
};

export default LanguageLoader;